module.exports = __webpack_public_path__ + "img/flag-es.7b1ec722.svg";